// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__AdSS6","author":"Table_author__WzPQq","authorImage":"Table_authorImage__14RtQ","unreadRow":"Table_unreadRow__1qeyg"};